import {
  EllipseMarker
} from "@/plugins/markerjs2";

export class HighlightEllipseMarker extends EllipseMarker {
  constructor(container, overlayContainer, settings) {
    super(container, overlayContainer, settings);
    this.strokeWidth = 0;
    this.opacity = 0.25; 
  }
  getState() {
    const result = Object.assign(
      {
        strokeWidth: this.strokeWidth,
        opacity: this.opacity,
      },
      super.getState()
    );
    result.typeName = HighlightEllipseMarker.typeName;

    return result;
  }

  restoreState(state) {
    const ellipseState = state;
    this.strokeWidth = ellipseState.strokeWidth;
    this.opacity = ellipseState.opacity;
    super.restoreState(state);
  }
}

HighlightEllipseMarker.typeName = "HighlightEllipseMarker";
HighlightEllipseMarker.title = "Ellipse Highlighter";
HighlightEllipseMarker.icon = '<svg viewBox="0 0 24 24"><path d="M12 4C6.5 4 2 7.58 2 12s4.5 8 10 8 10-3.58 10-8-4.5-8-10-8z"/></svg>';
